function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/* Responsible for holding and controling the carousel's current slide */
import { useEffect, useRef, useState } from 'react';
import { useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import euclideanModulus from './utils/euclidean-modulus';
var useCarousel = _ref => {
  var items = _ref.items,
    initialIndex = _ref.initialIndex,
    onSlideChange = _ref.onSlideChange,
    onSlideLeft = _ref.onSlideLeft,
    onSlideRight = _ref.onSlideRight;
  var _useState = useState(initialIndex),
    _useState2 = _slicedToArray(_useState, 2),
    selectedIndex = _useState2[0],
    setSelectedIndex = _useState2[1];
  var lastSlide = useRef(initialIndex);
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var generateSlideChangeEvents = (nextSlide, currentSlide) => {
    onSlideChange(nextSlide, currentSlide);
    var movedLeft = nextSlide === euclideanModulus(currentSlide - 1, items.length);
    var movedRight = nextSlide === euclideanModulus(currentSlide + 1, items.length);
    var slide = items[nextSlide];
    var left = () => {
      sendEvent('carousel-change', {
        slide: nextSlide,
        direction: 'left',
        url: slide.imageSrc,
        type: slide.type
      });
      onSlideLeft(nextSlide, currentSlide);
    };
    var right = () => {
      sendEvent('carousel-change', {
        slide: nextSlide,
        direction: 'right',
        url: slide.imageSrc,
        type: slide.type
      });
      onSlideRight(nextSlide, currentSlide);
    };

    // It's possible to have moved both left and right if there are only two photos. In that case we will preserve
    // the preexisting behaviour of assuming the carousel doesn't wrap.
    if (movedLeft && movedRight) {
      if (nextSlide < currentSlide) {
        left();
      } else {
        right();
      }
    } else if (movedLeft) {
      left();
    } else if (movedRight) {
      right();
    } else {
      // Moved, but more than one space left or right
      sendEvent('carousel-change', {
        slide: nextSlide,
        url: slide.imageSrc,
        type: slide.type
      });
    }
  };
  useEffect(() => {
    generateSlideChangeEvents(selectedIndex, lastSlide.current);
    lastSlide.current = selectedIndex;
  }, [selectedIndex]); // eslint-disable-line react-hooks/exhaustive-deps

  var handleSlideChange = newSlide => {
    if (newSlide !== selectedIndex) {
      var newIndex = euclideanModulus(newSlide, items.length);
      setSelectedIndex(newIndex);
      return newIndex;
    }
    return selectedIndex;
  };
  return {
    updateSelectedIndex: handleSlideChange,
    selectedIndex
  };
};
export default useCarousel;